import React, { Fragment } from 'react';

/**
 * Components
 */
import Heading from 'components/heading/heading';
import IconHandMoney from '../../assets/svg/icon-hand-money.svg';

const ModalPayment = () => {
  return (
    <Fragment>
      <Heading text="Make Payment" icon={IconHandMoney} />
    </Fragment>
  )
};

export default ModalPayment;
